import { createStyles } from 'antd-style';

const useProposalDetailStyles = createStyles(({ token, css }) => ({
  container: css`
    min-height: 100vh;
    background: var(--color-bg-layout);
  `,
  breadcrumbWrapper: css`
    border-radius: 15px;
    padding: 12px;
    margin-bottom: 24px;
  `,
  title: css`
    width: 80%;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    color: ${token.colorText};
  `,
  content: css`
    max-width: 816px;
    margin: 0 auto;
    padding: 32px 24px;
    background: var(--color-bg-container);
    color: var(--color-text-base);
  `,

  breadcrumb: css`
    .ant-breadcrumb-link {
      color: ${token.colorTextSecondary};
      transition: color 0.2s;

      &:hover {
        color: ${token.colorText};
      }
    }
  `,
  descriptionContent: css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    .ant-typography {
      margin-bottom: 15px;
      color: ${token.colorTextTertiary};
    }
    width: 80%;
  `,

  titleSection: css`
    display: flex;
    justify-content: space-between;
    align-items: center;

    .action-buttons {
      display: flex;
      gap: 12px;
    }
  `,

  sourceInfo: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,

  userInfo: css`
    display: flex;
    align-items: center;
    gap: 16px;
  `,

  userDetails: css`
    display: flex;
    .user-meta {
      color: ${token.colorTextSecondary};
      font-size: 14px;
      margin-right: 8px;

      .user-name {
        color: ${token.colorText};
        font-weight: 600;
        margin: 0 4px;
      }

      .company {
        color: ${token.colorTextTertiary};
        margin-left: 4px;
      }
    }
  `,
  thumbnailContainer: css`
    width: 140px;
    height: 100px;
    border-radius: 13px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,

  descriptionSection: css`
    display: flex;
    align-items: flex-start;
    gap: 24px;

    .description-content {
      flex: 1;

      .ant-typography-paragraph {
        font-size: 16px;
        line-height: 1.6;
        color: ${token.colorTextSecondary};
        margin-bottom: 0 !important;
      }
    }

    .thumbnail-container {
      width: 120px;
      height: 120px;
      background: linear-gradient(
        135deg,
        ${token.blue1} 0%,
        ${token.purple1} 50%,
        ${token.pink1} 100%
      );
      border-radius: ${token.borderRadiusLG}px;
      overflow: hidden;
      box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  `,

  stepsSection: css`
    padding: 24px;
    border-radius: ${token.borderRadiusLG}px;

    .steps-header {
      text-align: center;
      margin-bottom: 32px;

      .steps-title {
        font-size: 20px;
        font-weight: 600;
        color: ${token.colorText};
        margin-bottom: 8px;
      }

      .steps-subtitle {
        font-size: 14px;
        color: ${token.colorTextSecondary};
      }
    }

    .custom-steps {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 48px;

      .step-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .step-icon {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          margin-bottom: 12px;
          transition: all 0.3s;
          border: 2px solid ${token.colorBorder};
          background: ${token.colorBgContainer};
          color: ${token.colorTextSecondary};

          &.active {
            background: ${token.colorPrimary};
            border-color: ${token.colorPrimary};
            color: white;
            box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
          }

          &.completed {
            background: ${token.colorSuccess};
            border-color: ${token.colorSuccess};
            color: white;
          }
        }

        .step-content {
          text-align: center;

          .step-title {
            font-size: 16px;
            font-weight: 600;
            color: ${token.colorText};
            margin-bottom: 4px;

            &.active {
              color: ${token.colorPrimary};
            }
          }

          .step-description {
            font-size: 12px;
            color: ${token.colorTextTertiary};
            max-width: 120px;
            line-height: 1.4;
          }
        }

        &:not(:last-child)::after {
          content: '';
          position: absolute;
          top: 24px;
          left: calc(100% + 24px);
          width: 48px;
          height: 2px;
          background: ${token.colorBorder};
          transition: background 0.3s;

          &.completed {
            background: ${token.colorSuccess};
          }
        }

        &.completed:not(:last-child)::after {
          background: ${token.colorSuccess};
        }
      }
    }

    .progress-bar {
      margin-top: 24px;
      height: 4px;
      background: ${token.colorFillSecondary};
      border-radius: 2px;
      overflow: hidden;

      .progress-fill {
        height: 100%;
        background: linear-gradient(
          90deg,
          ${token.colorPrimary},
          ${token.colorPrimaryActive}
        );
        border-radius: 2px;
        transition: width 0.5s ease;
      }
    }
  `,

  previewSection: css`
    border-radius: 15px;
    padding: 12px;
    .section-title {
      margin-bottom: 24px !important;
    }
  `,

  previewArea: css`
    border-radius: ${token.borderRadiusLG}px;
    padding: 24px;
  `,

  previewCard: css`
    box-shadow: none !important;

    .ant-card-body {
      padding: 0;
    }

    .preview-image {
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        height: 384px;
        object-fit: cover;
        transition: transform 0.3s;
      }

      &:hover img {
        transform: scale(1.05);
      }

      .preview-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        transition: background 0.3s;

        .overlay-buttons {
          opacity: 0;
          transition: opacity 0.3s;
        }
      }

      &:hover .preview-overlay {
        background: rgba(0, 0, 0, 0.3);

        .overlay-buttons {
          opacity: 1;
        }
      }
    }

    .preview-info {
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info-left {
        display: flex;
        align-items: center;
        gap: 12px;

        .type-icon {
          width: 32px;
          height: 32px;
          border-radius: ${token.borderRadius}px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;

          &.images {
            background: ${token.green1};
            color: ${token.green6};
          }

          &.ppt {
            background: ${token.orange1};
            color: ${token.orange6};
          }

          &.word {
            background: ${token.blue1};
            color: ${token.blue6};
          }
        }

        .info-text {
          .title {
            font-weight: 600;
            color: ${token.colorText};
            margin-bottom: 4px;
          }

          .meta {
            font-size: 12px;
            color: ${token.colorTextTertiary};
          }
        }
      }

      .info-actions {
        display: flex;
        gap: 8px;
      }
    }
  `,

  contentGrid: css`
    margin-bottom: 24px;

    .grid-title {
      margin-bottom: 16px !important;
    }
  `,

  scrollContainer: css`
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: thin;
    scrollbar-color: ${token.colorFillTertiary} ${token.colorFillSecondary};

    &::-webkit-scrollbar {
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: ${token.colorFillSecondary};
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${token.colorFillTertiary};
      border-radius: 3px;

      &:hover {
        background: ${token.colorFill};
      }
    }
  `,

  itemsContainer: css`
    display: flex;
    gap: 16px;
    min-width: max-content;
    padding-bottom: 10px;
  `,

  contentItem: css`
    width: 100px;
    height: 68px;
    flex-shrink: 0;
    border: 2px solid ${token.colorBorder};
    border-radius: ${token.borderRadius}px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    background: ${token.colorBgContainer};

    &:hover {
      border-color: ${token.colorBorderHover};
      box-shadow: ${token.boxShadowSecondary};
    }

    &.selected {
    }

    .item-image {
      position: relative;
      height: 68px; /* Fixed height to ensure consistent positioning */
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .anticon {
        width: 100%;
        height: 100%;
        display: flex !important;
        align-items: center;
        justify-content: center;
      }

      .type-badge {
        position: absolute;
        top: 8px;
        left: 8px;
        padding: 2px 8px;
        border-radius: ${token.borderRadiusSM}px;
        font-size: 12px;
        font-weight: 500;

        &.image {
          background: ${token.green1};
          color: ${token.green6};
        }
        &.markdown {
          background: ${token.blue1};
          color: ${token.blue6};
        }
        &.video {
          background: ${token.purple1};
          color: ${token.purple6};
        }
        &.pdf {
          background: ${token.red1};
          color: ${token.red6};
        }
      }

      .selected-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(24, 144, 255, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;

        .selected-icon {
          width: 32px;
          height: 32px;
          background: ${token.colorPrimary};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 16px;
        }
      }
    }

    .item-info {
      padding: 12px;

      .item-meta {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;

        .meta-icon {
          width: 20px;
          height: 20px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;

          &.image {
            background: ${token.green1};
            color: ${token.green6};
          }
          &.markdown {
            background: ${token.blue1};
            color: ${token.blue6};
          }
          &.video {
            background: ${token.purple1};
            color: ${token.purple6};
          }
          &.pdf {
            background: ${token.red1};
            color: ${token.red6};
          }
        }

        .item-index {
          font-size: 12px;
          color: ${token.colorTextTertiary};
        }
      }

      .item-title {
        font-weight: 500;
        color: ${token.colorText};
        font-size: 14px;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  `,

  bottomActions: css`
    display: flex;
    justify-content: center;
    gap: 16px;
    width: 100%;
    padding: 24px;
  `,
  editActions: css`
    display: flex;
    justify-content: center;
    gap: 16px;
    width: 100%;
    align-items: center;
    flex-wrap: wrap;
  `,
  primaryButton: css`
    flex: 2;
    min-width: 120px;
    height: 40px;
    background: ${token.colorPrimary};
    color: white;
    font-size: 14px;
    padding: 8px 16px;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: ${token.colorPrimaryHover};
      transform: translateY(-1px);
    }
  `,
  secondaryButton: css`
    flex: 1;
    min-width: 80px;
    height: 40px;
    background: ${token.colorFillSecondary};
    border-radius: 20px;
    border: none;
    color: ${token.colorText};
    font-size: 14px;
    padding: 8px 16px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: ${token.colorFillTertiary};
      transform: translateY(-1px);
    }
  `,
  emptyButton: css`
    flex: 1;
    min-width: 80px;
  `,
  editLayout: css`
    display: flex;
    flex-direction: row;
    gap: 32px;
    margin-top: 32px;
    @media (max-width: 900px) {
      flex-direction: column;
      gap: 16px;
    }
  `,
  editFormWrapper: css`
    flex: 1.2;
    min-width: 320px;
    max-width: 420px;
  `,
  editFormCard: css`
    border-radius: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    padding: 32px 24px 24px 24px;
    background: #fff;
  `,
  editContentWrapper: css`
    flex: 2;
    min-width: 320px;
  `,
  editContentCard: css`
    border-radius: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    padding: 32px 24px 24px 24px;
    background: #fff;
    min-height: 320px;
  `,
  editContentTitle: css`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #222;
  `,
  editMainWrapper: css`
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin-top: 32px;
  `,
  editTopRow: css`
    display: flex;
    flex-direction: row;
    gap: 32px;
    @media (max-width: 900px) {
      flex-direction: column;
      gap: 16px;
    }
  `,
  editFormLeft: css`
    flex: 1.2;
    min-width: 320px;
    max-width: 420px;
  `,
  coverPreviewRight: css`
    flex: 1;
    min-width: 220px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: transparent;
    border-radius: 16px;
    min-height: 180px;
    max-width: 362px;
    border: none;
    position: relative;
    height: 362px;
  `,
  coverPreviewCard: css`
    position: relative;
    width: 264px;
    min-height: 370px;
    background: var(--cover-bg, #f5f5f5);
    border-radius: 40px;
    overflow: hidden;
  `,
  coverPreviewImg: css`
    width: 100%;
    height: 260px;
    object-fit: cover;
    display: block;
    border-radius: 40px 40px 0 0;
    background: #f5f5f5;
    mask-image: var(--cover-mask);
    mask-size: 94% 94%;
    mask-position: center;
    mask-repeat: no-repeat;
    -webkit-mask-image: var(--cover-mask);
    -webkit-mask-size: 94% 94%;
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
  `,
  coverPreviewTitle: css`
    position: absolute;
    width: 170px;
    top: 262px;
    left: 24px;
    font-weight: 600;
    color: var(--syn-1, #222);
    font-size: 13px;
    font-family: 'Poppins', Helvetica;
    z-index: 3;
    text-align: left;
    line-height: 1.2;
    /* Multi-line text overflow (2 lines max) */
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-height: 2.4em;
  `,
  coverPreviewSubtitle: css`
    position: absolute;
    width: 176px;
    height: 68px;
    top: 285px;
    left: 24px;
    font-weight: 400;
    color: var(--syn-1, #222);
    font-size: 11.3px;
    font-family: 'Poppins', Helvetica;
    z-index: 3;
    text-align: left;
    line-height: 1.4;
    /* Multi-line text overflow (4 lines max) */
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-height: 5.6em; /* 4 lines * 1.4 line-height = 5.6em */
  `,
  coverPreviewPlaceholder: css`
    width: 265px;
    height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #bbb;
    font-size: 16px;
    background: #f5f5f5;
    border-radius: 40px;
    border: 1px dashed #eee;
  `,
  uploadListSection: css`
    margin-top: 32px;
  `,
  uploadListTitle: css`
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #222;
  `,
  uploadListWrapper: css`
    display: flex;
    flex-direction: row;
    gap: 16px;
    flex-wrap: wrap;
    align-items: flex-start;
  `,
  uploadFileItem: css`
    position: relative;
    width: 120px;
    min-height: 120px;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 12px 8px 8px 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  `,
  uploadFileThumb: css`
    width: 80px;
    height: 60px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    border-radius: 6px;
    overflow: hidden;
  `,
  uploadFileName: css`
    font-size: 13px;
    color: #333;
    text-align: center;
    margin-bottom: 4px;
    word-break: break-all;
    max-width: 100px;
  `,
  uploadFileRemove: css`
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 2;
    background: #fff;
    border: 1px solid #eee;
    color: #ff4d4f;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  `,
  uploadAddButton: css`
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed #bbb;
    background: #fafbfc;
    color: #888;
    border-radius: 10px;
    font-size: 16px;
    flex-direction: column;
    cursor: pointer;
    transition: border-color 0.2s;
    &:hover {
      border-color: #1890ff;
      color: #1890ff;
    }
  `,
  resultStepWrapper: css`
    display: flex;
    flex-direction: row;
    gap: 32px;
    margin-top: 32px;
    min-height: 380px;
  `,
  resultLeft: css`
    flex: 1 1 320px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    padding: 24px 20px 24px 24px;
    min-width: 320px;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 380px;
  `,
  noComments: css`
    color: #aaa;
    text-align: center;
    margin-top: 32px;
    font-size: 15px;
  `,
  resultRight: css`
    flex: 2 1 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-width: 0;
    min-height: 380px;
  `,
  resultLineChart: css`
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    padding: 24px 24px 12px 24px;
    min-height: 180px;
    margin-bottom: 0;
  `,
  resultRadarChart: css`
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    padding: 24px 24px 12px 24px;
    min-height: 180px;
    margin-top: 0;
  `,
  resultRadarChartPlaceholder: css`
    display: none;
  `,
  feedbackSection: css`
    background: ${token.colorBgContainer};
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 24px;
    min-height: 400px;
    position: relative;
    z-index: 1000;
  `,
  feedbackHeader: css`
    margin-bottom: 16px;
  `,
  feedbackTitle: css`
    font-size: 18px;
    font-weight: 600;
    color: ${token.colorText};
    margin: 0;
  `,

  // Text overflow utility classes
  singleLineEllipsis: css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `,

  twoLineEllipsis: css`
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    line-height: 1.5;
    max-height: 3em;
  `,

  threeLineEllipsis: css`
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    line-height: 1.5;
    max-height: 9em;
    margin-bottom: 12px;
  `,

  userNameEllipsis: css`
    display: inline-block;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  `,

  // Drawer styles
  drawerBody: css`
    padding: 0 24px 24px 24px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari */
    }
  `,

  drawerHeader: css`
    padding: 16px 24px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  `,

  // File preview styles
  filePreviewCenter: css`
    text-align: center;
    padding: 48px 0;
  `,

  filePreviewIcon: css`
    font-size: 48px;
    color: #aaa;
  `,

  filePreviewTitle: css`
    margin: 16px 0;
  `,

  // Cover preview styles
  coverPreviewContainer: css`
    --cover-bg: var(--cover-bg);
    --cover-mask: var(--cover-mask);
  `,

  // Breadcrumb arrow styles
  breadcrumbArrow: css`
    font-size: 10px;
  `,

  breadcrumbItem: css`
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    gap: 4px;
    font-size: 10px;
  `,

  // Tab navigation styles
  tabNavigation: css`
    display: flex;
    align-items: center;
    gap: 24px;
    justify-content: space-around;
  `,

  tabItem: css`
    cursor: pointer;
    font-weight: 400;
    color: var(--color-text-tertiary);
    font-size: 18px;
    background: transparent;
    border: none;
    outline: none;
    padding: 4px 16px;
    border-radius: 18px;
    transition: color 0.2s;

    &.active {
      font-weight: 600;
      color: #000;
      background: var(--color-assist-7);
    }
  `,

  // Loading and error states
  centerContainer: css`
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,

  // Cover preview placeholder for no image state
  coverImagePlaceholder: css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    color: #999;
    font-size: 14px;
  `,

  // Optimize mode switch styles
  optimizeModeSwitch: css`
    &.ant-switch {
      background-color: var(--color-assist-7) !important;
    }

    &.ant-switch .ant-switch-handle::before {
      background-color: #fff !important;
    }

    &.ant-switch:hover {
      background-color: #e09b0c !important;
    }

    &.ant-switch:focus {
      box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2) !important;
    }
  `,

  // Optimize mode button styles
  optimizeModeButton: css`
    &.ant-btn {
      background-color: var(--color-assist-7) !important;
      border-color: var(--color-assist-7) !important;
      color: #fff !important;
    }

    &.ant-btn:hover {
      background-color: #e09b0c !important;
      border-color: #e09b0c !important;
      color: #fff !important;
    }

    &.ant-btn:focus {
      background-color: var(--color-assist-7) !important;
      border-color: var(--color-assist-7) !important;
      color: #fff !important;
      box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2) !important;
    }
  `,

  // Optimize mode overlay styles
  optimizeModeOverlay: css`
    background-color: var(--color-assist-7) !important;
    color: #fff !important;

    &:hover {
      background-color: #e09b0c !important;
    }
  `,

  // Steps item tail styles (commented out to allow normal display)
  stepsItemTail: css`
    /* 注释掉隐藏连接线的样式，让Steps组件的连接线正常显示 */
    /* &.ant-steps-item-tail {
      display: none !important;
    }

    &.ant-steps-item-tail::after {
      display: none !important;
    } */
  `,
}));
export default useProposalDetailStyles;
